import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Button, Slide, Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LockIcon from "@mui/icons-material/Lock";
import BottomSheet from "../../components/BottomSheet";
import PageHeader from "../../components/PageHeader";
import ApiService from "./../../services/api-service";
import notifier from "./../../components/Notifier";
import Loader from "./../../components/Loader";
import { Images } from "./../../assets/common";
import {
  getErrorString,
  getUserDetail,
  getUserId,
  isOwner,
  convertHMS,
  isOwnerId,
} from "./../../constants/function";
import AddPopup from "./../../components/AddPopup";
import ConfirmPlayListNft from "../../components/ConfirmPlaylistNft";
import { useParams, useHistory } from "react-router-dom";
import NoData from "../../components/Nodata";
import Chips from "../../components/Chips";
import ProfileMenu from "../../components/ProfileMenu";
import "./index.scss";
import OutsideClickHandler from "react-outside-click-handler";
import MusicCard from "../../components/MusicCard";
import { addSongAction, addSongsAction } from "./../../action/songs";
import { useDispatch } from "react-redux";
import ConfirmPopup from "./../../components/ConfirmPopup";
import { useTranslation } from "react-i18next";

export default function Playlists({ isList, isPrivate }) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const [active, setActive] = useState(0);
  const history = useHistory();
  const { _id } = useParams();
  const [open, setOpen] = React.useState(false);
  const [playlist, setPlaylist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addPlaylist, setaddPlaylist] = React.useState(false);
  const [editPlaylist, seteditPlaylist] = React.useState(false);
  const [pageNo, setPageNo] = useState(1);
  const userDetail = getUserDetail();
  const [selectedId, setSelectedAlbum] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const toggleDrawer = (value, id, index) => {
    setOpen(value);
    setSelectedIndex(index);
    setSelectedAlbum(id);
    if (value && id) {
      setOpen(false);
      makeAction(value, id, index);
    }
  };
  const makeAction = async (key, id, index) => {
    switch (key) {
      case "Remove Playlist":
        setOpenConfirm(true);
        break;
      case "m26":
        if (
          active > 0 &&
          !isOwnerId(playlist[index]["createdBy"]) &&
          !playlist[index]["isSubscribed"] &&
          playlist[index]["private"]
        ) {
          notifier.error(t("notifier.error.toast5"));
        } else if (typeof playlist[index].music === "number") {
          const tempMusic = await getPlayListMusic(id);
          if (tempMusic.length)
            dispatch(
              addSongsAction(tempMusic, false, playlist[index]["_id"], 0)
            );
        } else
          dispatch(
            addSongsAction(
              playlist[index].music,
              false,
              playlist[index]["_id"],
              0
            )
          );

        break;
      case "m27":
        history.push(
          `/app/PlaylistStatics/${id}/${playlist[index]["createdBy"]}`
        );
        break;
      case "m30":
        setSelectedAlbum(id);
        seteditPlaylist(true);
        break;
      case "Sell NFT":
        history.push(`/app/SellAuctionPlayList/${playlist[index]["nftId"]}`);

        break;
      case "m6":
        markPrivate(id, index);
        break;
      case "m5":
        markPrivate(id, index);
        break;
      default:
        break;
    }
  };
  const getPlayListMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: 1,
        pageSize: 100,
      });

      setLoading(false);

      return response["result"]["music"] || [];
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Artist has no music")
        notifier.error(getErrorString(error));
      return [];
    }
  };

  const deletePlaylist = async (id, index) => {
    try {
      setOpenConfirm(false);
      setLoading(true);
      const response = await ApiService.DELETE_PLAYLIST(id);
      setPlaylist(playlist.filter((_, i) => i !== index));

      setLoading(false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userDetail) {
      let tab = 0;
      switch (_id) {
        case "Me":
          setActive(0);
          tab = 0;
          getPlaylist(userDetail["_id"], tab, pageNo);
          break;
        case "BuyMe":
          setActive(1);
          tab = 1;
          getPlaylist(userDetail["_id"], tab, pageNo);
          break;
        case "Saved":
          setActive(2);
          tab = 2;
          getPlaylist(userDetail["_id"], tab, pageNo);
          break;
        case "MostListen":
          setActive(3);
          tab = 3;
          getPlaylist(userDetail["_id"], tab, pageNo);
          break;
        case "MostTipped":
          setActive(4);
          tab = 4;
          getPlaylist(userDetail["_id"], tab, pageNo);
          break;
        default:
          setActive(0);
          getPlaylist(userDetail["_id"], tab, 1);
          break;
      }
    }
  }, [_id]);

  const getPlaylist = async (_id, tab, pageNo) => {
    try {
      setLoading(true);
      const response =
        // (_id || userDetail["_id"]) && tab === 0
        //   ? await ApiService.PLAYLIST(
        //       {
        //         id: userDetail["_id"],
        //         pageNo: pageNo,
        //         pageSize: 10,
        //       },
        //       true
        //     )
        //   :
        tab === 0
          ? await ApiService.TOPTEN_MY_PLAYLIST({
              pageNo: pageNo,
              pageSize: 10,
            })
          : tab === 1
          ? await ApiService.TOPTEN_BUY_ME_PLAYLIST({
              pageNo: pageNo,
              pageSize: 10,
            })
          : tab === 2
          ? await ApiService.TOPTEN_SAVED_PLAYLIST()
          : tab === 3
          ? await ApiService.TOPTEN_LISTEN_PLAYLIST()
          : await ApiService.TOPTEN_TIP_PLAYLIST();
      setLoading(false);
      if (tab === 0 && pageNo === 1) {
        setLoaded(response["result"].length < 10 ? true : false);
        setPlaylist([...response["result"]]);
      } else if (tab === 0 && pageNo > 1) {
        setLoaded(response["result"].length < 10 ? true : false);
        setPlaylist([...playlist, ...response["result"]]);
      } else setPlaylist([...response["result"]]);
    } catch (error) {
      setLoading(false);
      setPlaylist([]);
      notifier.error(getErrorString(error));
    }
  };
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded && active === 0) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      getPlaylist(_id ? _id : userDetail["_id"], active, next);
    }
  };
  const handleClosePopup = (e, close, url, explicit) => {
    setaddPlaylist(close);
    seteditPlaylist(close);
    if (e && typeof e === "object" && !close && !url) {
      setPlaylist([e, ...playlist]);
    } else if (url || typeof explicit === "boolean") {
      setPlaylist(playlist.map((item, i) => {
        if (i !== e) return item;
        return {
          ...item,
          ...(url ? { GIF: url } : {}),
          ...(typeof explicit === "boolean" ? { isExplicit: explicit } : {}),
        };
      }));
    } else {
      setaddPlaylist(false);
      seteditPlaylist(false);
    }
  };

  const markPrivate = async (id, index) => {
    try {
      setLoading(true);
      const response = await ApiService.ASSET_PRIVACY({
        assetId: id,
        type: "playlist",
        private: !playlist[index].private,
      });
      //makeing nft public private
      const response1 = await ApiService.ASSET_PRIVACY({
        assetId: playlist[index]?.nftDetails?._id,
        type: "playlistNFT",
        private: !playlist[index].private,
      });
      setPlaylist(playlist.map((item, i) =>
        i === index ? { ...item, private: !item.private } : item
      ));
      notifier.success(response["result"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      setPlaylist([]);
      setPageNo(0);
    };
  }, []);

  return (
    <Box className="__playlists__">
      <Box
        className="__main_pading"
        onScroll={(e) => handleScroll(e.target)}
        sx={{ height: "100vh", overflow: "scroll" }}
      >


        <Box
          sx={{
            position: "relative",
            flexWrap: "wrap",
            minHeight: "100px",
          }}
          className="__playlists_card flex-responsive"
        >
          {(!_id || _id === "Me") && active === 0 ? (
            <Box>
              <Box
                className="__card__add _cp"
                sx={{
                  border: "2px dashed #999999",
                  borderRadius: "6px",

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => setaddPlaylist(true)}
              >
                <AddIcon style={{ color: "#999999", fontSize: "50px" }} />
              </Box>
              <Typography className="fs-14">{t("Create New Playlist")}</Typography>
            </Box>
          ) : null}

          {playlist.length > 0 &&
            playlist.map((p, index) => (
              <MusicCard
                tip={p?.tip}
                tab={active}
                listens={p?.listens}
                platform={p?.nftDetails?.platform || p?.platform}
                isPlaylist={true}
                isPlaylistNft={
                  (p.nftId || p?.nftDetails) && active < 2 ? true : false
                }
                music={p}
                nftId={p?.nftDetails?._id}
                key={p.GIF ? p.GIF.filePath : p._id}
                actions={
                  isOwner(
                    p["owner"] && typeof p["owner"] === "object"
                      ? p["owner"]["email"]
                      : p["createdByDetails"]
                      ? p["createdByDetails"]["email"]
                      : p["uploader"]
                      ? p["uploader"]["email"]
                      : ""
                  )
                    ? [
                        p?.music > 0
                          ? { key: "m26", action: t("dropMenu.m26") }
                          : "",
                        // "Remove Studio",
                        { key: "m30", action: t("dropMenu.m30") },
                        { key: "m27", action: t("dropMenu.m27") },
                        p["private"]
                          ? { key: "m5", action: t("dropMenu.m5") }
                          : { key: "m6", action: t("dropMenu.m6") },
                        // p["nftId"] ? "Sell NFT" : "",
                      ]
                    : [
                        { key: "m26", action: t("dropMenu.m26") },
                        { key: "m27", action: t("dropMenu.m27") },
                        p["private"]
                          ? { key: "m5", action: t("dropMenu.m5") }
                          : { key: "m6", action: t("dropMenu.m6") },
                      ]
                }
                toggleMenu={(action) => toggleDrawer(action, p["_id"], index)}
                cardIndex={index}
              />
            ))}
          {playlist.length === 0 && active !== 0 ? (
            <NoData lable={t("No Playlists")} />
          ) : null}
        </Box>
      </Box>

      {addPlaylist ? (
        <AddPopup
          api="playlist"
          title={t("addPopup.title1")}
          open={addPlaylist}
          handleClose={(e, close) => handleClosePopup(e, close)}
        />
      ) : null}

      {editPlaylist ? (
        <AddPopup
          selectedIndex={selectedIndex}
          id={selectedId}
          api="playlist"
          image={
            playlist[selectedIndex]["GIF"]
              ? playlist[selectedIndex]["GIF"]["filePath"]
              : playlist[selectedIndex]["thumbnailImg"]
              ? playlist[selectedIndex]["thumbnailImg"]["filePath"]
              : ""
          }
          title={t("addPopup.title2")}
          isExplicit={playlist[selectedIndex]["isExplicit"]}
          open={editPlaylist}
          handleClose={(e, close, url, explicit) =>
            handleClosePopup(e, close, url, explicit)
          }
        />
      ) : null}

      {openConfirm && playlist.length > 0 ? (
        <ConfirmPopup
          id={selectedId}
          index={selectedIndex}
          message={`${t("confirmPopup.text1")} "${
            playlist[selectedIndex]["title"]
          }" ${t("confirmPopup.text2")}?`}
          open={openConfirm}
          handleClose={(e, id, index) =>
            e ? deletePlaylist(id, index) : setOpenConfirm(false)
          }
        />
      ) : null}

      {loading ? <Loader /> : null}

    </Box>
  );
}